import OpenAccount from "../components/Individuals/OpenAccount";
import Currency from "../components/Individuals/Currency";
import HowToGetStarted from "../components/common/HowToGetStarted";
import Footer from "../components/Footer";
import background from '../assets/freedom/background.png'
import cylinder from '../assets/freedom/cylinder.png'
import FirstSection from "../components/common/FirstSection";
import contactForm from '../assets/contact-form-background.png';
import { IndividualContactForm } from "../components/common/ReusableContactForm";
const Individuals: React.FC = () => {
    const individualSteps = [
      {
        number: "1",
        title: "CREATE\nYOUR ACCOUNT",
        description:
          "SIGN UP QUICKLY AND EASILY\nTO ACCESS YOUR\nEPAYR  E-WALLET",
      },
      {
        number: "2",
        title: "LINK TO\nTHE PLATFORM",
        description:
          "CONNECT YOUR E-WALLET TO OUR\nSECURE PLATFORM FOR COMPLETE\nCONTROL OVER YOUR TRANSACTIONS",
      },
      {
        number: "3",
        title: "START MANAGING\nYOUR FINANCES",
        description:
          "BEGIN USING THE E-WALLET\nTO MAKE PAYMENTS, TRANSFER\nFUNDS, AND EXCHANGE CURRENCIES",
      },
    ];
    return (
          <main>
            <FirstSection 
              icon={cylinder}
              iconAlt="Suite icon"
              backgroundImage={background}
              backgroundColor="none"
              title="Your money,<br/> your freedom"
              titleColor="beige.100"
              description={
                  <>
                  Get access today to a range<br/>
                  of powerful tools for simplifying<br/>
                  your money management
                  </>
              }
              descriptionColor="lightPurple.300"
               buttonText="CONTACT US"
              buttonHref="/contact"
              heading="take control<br/>of your finances<br/>with EPAYR e-wallet"
              mobileHeading="take control of<br/>your finances with<br/>EPAYR e-wallet"
              headingColor="darkPurple.500"
              buttonVariant="lightPurple"
              leftColumnSize={{ xs: 12, md: 4 }}
              rightColumnSize={{ xs: 12, md: 8 }}
              leftColumnSx={{
                  backgroundColor: "darkPurple.500"
              }}
              headingStyle={{
                textWrap: "nowrap"
              }}
              />
            <OpenAccount/>
            <Currency/>
            <HowToGetStarted steps={individualSteps}/>
            <IndividualContactForm background={contactForm}/>
            <Footer 
              buttonText="LEARN MORE" 
              buttonLink="/individuals-pricing"
              ctaText={{
                prefix: 'LEARN MORE ABOUT',
                highlight1: ' PRICING',
                middle: '',
                highlight2: '',
                suffix: ''
              }}
            />
          </main>
    );
  };
  
  export default Individuals;
  